import { render, staticRenderFns } from "./standardDispose.vue?vue&type=template&id=714a78ad&scoped=true&"
import script from "./standardDispose.vue?vue&type=script&lang=js&"
export * from "./standardDispose.vue?vue&type=script&lang=js&"
import style0 from "./standardDispose.vue?vue&type=style&index=0&id=714a78ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714a78ad",
  null
  
)

export default component.exports